export default [
  {
    id: 'Your Class',
    description: 'Right now you are inside of the class: <br/> <br/>',
    seen: false,
    domID: 'onboarding-class-dropdown',
    classes: [{ 'onboarding-bottom-shift-left': true }],
  },
  {
    id: 'RoundTables',
    description:
      'This page contains all of the RoundTables in this class. <br><br> <b>RoundTables</b> are the core discussion activities in Parlay',
    seen: false,
    domID: 'onboarding-roundtables-nav-button',
    classes: [{ 'onboarding-bottom-shift-left': true }],
  },
  {
    id: 'Reports',
    description: 'Manage students and review engagement reports',
    seen: false,
    domID: 'onboarding-reports-nav-button',
    classes: [{ 'onboarding-bottom-shift-left': true }],
  },
  {
    id: 'Universe',
    description: 'Browse pre-made content in the <br/> <b>Parlay Universe</b>',
    seen: false,
    domID: 'onboarding-universe-nav-button',
    classes: [{ 'onboarding-bottom-shift-left': true }],
  },
  {
    id: 'Class Settings',
    description: 'Update class information: name and section',
    seen: false,
    domID: 'onboarding-class-settings-nav-button',
    classes: [{ 'onboarding-bottom-shift-left': true }],
  },
  {
    id: 'Create RoundTables',
    description:
      'Create new RoundTables and navigate between existing ones. <br/><br/>' +
      'There are <br/> <b>Written RoundTables</b> and <b>Verbal RoundTables</b> <br/>',
    // '<a style="color: yellow; line-height: 30px;" href="https://parlayideas.com/resources-meaningful-discussions/" target="_blank">Learn More</a>',
    seen: false,
    domID: 'onboarding-new-rt-button',
    classes: [{ 'onboarding-new-rt-button': true }],
  },
];



// WEBPACK FOOTER //
// ./src/app/features/onboarding/courseNavigationSteps.js